


export enum JsonEditorSchemaType {
    RuleSchema = "rule_schema",
    AnalysisConfigSchema = "analysis_config_schema",
    CalculationSchema = "calculation_schema",
    PlotSchema = "plot_schema",
    TableSchema = "table_schema",
    CustomReportSchema = "custom_report_schema",
}

